import type React from 'react';
import { URLS } from '../../../config/footerConfig';

export const PageFooter: React.FC = () => (
  <footer className="mobile-app-redirect__footer">
    <p className="mobile-app-redirect__copyright">Copyright © Sangoma. All rights reserved.</p>
    <p className="mobile-app-redirect__legal">
      <a href={URLS.termsOfUse} target="_blank" rel="noopener noreferrer">
        Terms of use
      </a>
      <span aria-hidden={true}>|</span>
      <a href={URLS.privacyPolicy} target="_blank" rel="noopener noreferrer">
        Privacy policy
      </a>
    </p>
  </footer>
);
